<template>
  <v-dialog v-model="dialog" class="carregar-modelo-dialog" max-width="1110" scrollable>
    <template v-slot:activator="{ on }">
      <mf-button v-if="primeiroValor" :label="buttonText" @click="dialog = true" />
      <mf-button v-else icon="add" :label="buttonText" @click="dialog = true" />
    </template>
    <v-card class="pa-6">
      <h1 class="dialog-title">Selecione um modelo para continuar</h1>
      <div class="options-container">
        <models-card
          v-for="card in segmentationModels"
          :key="card._id"
          :card="card"
          :selected-card="selected"
          @click="selected = card._id"
          @dblclick.native="doubleClick"
        />
      </div>

      <mf-action-buttons
        class="mt-8"
        :primary-button="{
          text: 'Selecionar',
          action: () => continuar(selected),
          isVisible: true,
          isLoading: loading,
          isDisabled: selected === null,
        }"
        :secondary-button="{
          text: 'Cancelar',
          action: cancel,
          isVisible: true,
        }"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import ModelsCard from '@/modules/clientes/segmentation/views/components/ModelsCard.vue'
import { mapState } from 'vuex'
import { mapWaitingActions } from 'vue-wait'

export default {
  components: {
    ModelsCard,
  },
  props: {
    buttonText: {
      type: String,
      default: 'Nova segmentação',
    },
    primeiroValor: Boolean,
  },
  data: () => ({
    dialog: false,
    loading: false,
    selected: '',
  }),
  computed: {
    ...mapState({
      segmentationModels: (state) => state.segmentation.segmentationModels,
    }),
  },
  mounted() {
    this.getData()
  },
  methods: {
    ...mapWaitingActions({
      getSegmentModelById: 'get-segment-by-id',
      getSegmentModels: 'get-segment-models',
    }),
    continuar(id) {
      this.dialog = false
      this.$emit('selected-model', id)
    },
    doubleClick() {
      this.continuar(this.selected)
    },
    cancel() {
      this.selected = ''
      this.dialog = false
    },

    async getData() {
      let modules = []
      const filter = { modules }
      await this.getSegmentModels(filter)
    },
  },
}
</script>

<style lang="scss">
.dialog-title {
  font-size: 18px;
  font-weight: 700;
  color: $cinza-d20;
}

.options-container {
  margin-top: 32px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}
</style>
